import api from '@pray/shared/utils/api';
// `itemId` is intentionally omitted from the request body: the backend derives the
// item key from the key-field value inside `data`, so sending item_id is redundant
// (and ignored). It stays in Props only because callers compute it for optimistic UI.
type Props = { artistId: string; catalogId: string; itemId: string; data: Record<string, string | number | boolean> };
export async function postCreateItem({ artistId, catalogId, data }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Backend returns only { item_id }. Unwrap the envelope one level — see getCatalogs.ts.
  const res = await api.executePostRequest<{ data: { item_id: string } }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/items`, { data });
  return res.data.data;
}
